import { useEffect, useState } from 'react';

export const SIDEBAR_SEARCH_SELECTOR = '.universal-search--sidebar, .nav-v2-search--rail';

const sidebarOwnsShortcut = () => !!document.querySelector(SIDEBAR_SEARCH_SELECTOR);

export default function useLocalSearchShortcut(target) {
  const [label, setLabel] = useState(null);

  useEffect(() => {
    if (sidebarOwnsShortcut()) return undefined;
    setLabel('⌘K');
    const onKey = (e) => {
      if (e.defaultPrevented) return;
      if (!(e.metaKey || e.ctrlKey) || e.key.toLowerCase() !== 'k') return;
      e.preventDefault();
      (typeof target === 'function' ? target() : target.current)?.focus();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [target]);

  return label;
}
